import React from "react";

const ErrorCmpxsLack = ({ loc }) => {
    return <h2 className="error-message">{loc("errors.cmpxsLack")}</h2>;
};

export default ErrorCmpxsLack;
